module.exports = __webpack_public_path__ + "img/vxingkuai2.prt.1663bcbb.jpg";